import React, { useState, useEffect } from 'react';

import { Tooltip, Fab } from "@mui/material";
import Grid from '@mui/material/Grid2';
import {
  Add,
  DeleteForever
} from "@mui/icons-material";

import { 
  StartEquipmentChoice, 
  StartEquipmentOption, 
} from "@dndModels";

import StartEquipmentOptionInput from "@dndComponents/equipment/StartEquipmentOptionInput";

interface Props {
  choice: StartEquipmentChoice;
  onChange: (choice: StartEquipmentChoice) => void; 
  onDelete: () => void; 
  disabled: boolean;
}

export default function StartEquipmentChoiceInput({ 
  choice,
  onChange,
  onDelete,
  disabled
}: Props) {
  const [my_choice, setChoice] = useState(choice.clone());
  const [reloading, setReloading] = useState(false);

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  return (
    <Grid container spacing={0} direction="row" style={{ paddingLeft: "4px" }}>
      <Grid
        size={{
          xs: 12
        }}>
        <span className="header">
          Options
        </span>
        { !disabled &&
        <Tooltip title={`Create New Option`}>
          <Fab size="small" color="primary" style={{marginLeft: "8px"}}
            onClick={ () => {
              const new_choice = my_choice;
              const option = new StartEquipmentOption();
              new_choice.options.push(option);
              setChoice(new_choice);
              onChange(new_choice);
              setReloading(true);
            }}>
            <Add/>
          </Fab>
        </Tooltip>
        }
        { !disabled &&
          <Tooltip title={`Remove Choice`}>
            <Fab size="small" color="primary" style={{marginLeft: "8px"}}
              onClick={ () => {
                onDelete();
              }}>
              <DeleteForever/>
            </Fab>
          </Tooltip>
        }
      </Grid>
      { !reloading && my_choice.options.map((opt, key) => {
        return (
          <Grid
            key={key}
            size={{
              xs: 12
            }}>
            <div style={{ paddingLeft: "4px", width: "calc(100% - 4px)" }}>
              <StartEquipmentOptionInput
                option={opt}
                disabled={disabled}
                onChange={(changed: StartEquipmentOption) => {
                  const new_choice = my_choice;
                  const option_finder = new_choice.options.filter(o => o.id === changed.id);
                  if (option_finder.length === 1) {
                    const option = option_finder[0];
                    option.copy(changed);
                    setChoice(new_choice);
                    onChange(new_choice);
                  }
                }}
                onDelete={() => {
                  const new_choice = my_choice;
                  new_choice.options = new_choice.options.filter(o => o.id !== opt.id);
                  setChoice(new_choice);
                  onChange(new_choice);
                  setReloading(true);
                }}
              />
            </div>
          </Grid>
        );
      })}
    </Grid>
  );
}
